// extracted by mini-css-extract-plugin
module.exports = {"button":"TypesOfRequestForm_button__aTlfO","left":"TypesOfRequestForm_left__mPNuF","form":"TypesOfRequestForm_form__UMXbW","selected":"TypesOfRequestForm_selected__l59xO"};